<template>
	<validation-observer v-slot="{ invalid }" ref="form" class="form mx-auto">
		<b-form @submit.prevent="submitForm">
			<slot name="header">
				<h4 class="mb-4">Change Company</h4>
			</slot>

			<div
				v-if="memberOptions.length && !assignees.length"
				class="mt-4 overflow-auto members"
			>
				<validation-provider :rules="{ required: true }">
					<b-form-checkbox @change="selectAll" class="text-capitalize"
						>All Users</b-form-checkbox
					>

					<b-form-group>
						<b-form-checkbox-group v-model="models.members" stacked>
							<b-form-checkbox
								v-for="member in memberOptions"
								:key="member.value"
								:value="member.value"
								>{{ member.text }}</b-form-checkbox
							>
						</b-form-checkbox-group>
					</b-form-group>
				</validation-provider>
			</div>

			<base-select
				v-model="models.company"
				:options="companyOptions"
				rules="required"
				name="Company"
				label="Company"
				placeholder="Select Company"
			></base-select>

			<div class="mt-4 d-flex justify-content-between">
				<slot name="return"></slot>
				<slot name="submit">
					<base-button
						:disabled="invalid"
						:loading="formProcessing"
						type="primary"
						native-type="submit"
						size="md"
						class="form-btn font-weight-normal"
					>
						<slot name="submit-text">Save</slot>
					</base-button>
				</slot>
			</div>
		</b-form>
	</validation-observer>
</template>

<script>
import { CompaniesService, MembersService } from "@services";

export default {
	name: "form-assign-company",
	props: {
		assignees: {
			type: Array,
		},
	},
	data() {
		return {
			formProcessing: false,
			companyOptions: [],
			memberOptions: [],
			models: {
				members: [],
				company: null,
			},
		};
	},
	watch: {
		formProcessing: function (val) {
			this.$bus.$emit("assign-company-form-processing", val);
		},
	},
	methods: {
		async fetchCompanies() {
			const response = await CompaniesService.list(
				{ page_size: 1000 },
				false
			);

			this.companyOptions = response.data.data.results.map((item) => {
				return { value: item.id, text: item.name };
			});
		},
		async fetchMembers() {
			const response = await MembersService.list(
				{ assign: "unassigned" },
				false
			);

			if (this.assignees)
				this.memberOptions = this.assignees.map((item) => {
					return {
						value: item.id,
						text: item.user_email,
						type: item.type,
						status: item.status,
					};
				});
			else
				this.memberOptions =
					response.data.data.results.data.members.results.map(
						(item) => {
							return {
								value: item.id,
								text: item.user_email,
								type: item.type,
								status: item.status,
							};
						}
					);
		},
		selectAll() {
			this.models.members =
				this.memberOptions.length == this.models.members.length
					? []
					: this.memberOptions.map((item) => item.id);
		},
		async submitForm() {
			this.formProcessing = true;

			for (const member of this.models.members) {
				const index = this.memberOptions.findIndex(
					(item) => item.value == member
				);
				const item = 0 <= index ? this.memberOptions[index] : null;

				if (item) {
					await MembersService.assignCompany({
						company_id: this.models.company,
						member_id: member,
						type: item.type.replace("Company", "Corporate"),
						status: item.status,
					});

					this.$bus.$emit("datatable-remove-item", {
						id: member,
					});
				}
			}

			this.$bus.$emit("assign-company-form-success", true);

			this.$toasted.show("Members assigned successfully");

			this.reset();
		},
		reset() {
			this.$refs.form.reset();

			Object.assign(this.$data, this.$options.data.apply(this));
		},
	},
	mounted() {
		this.fetchCompanies();
		this.fetchMembers();

		if (this.assignees)
			this.models.members = this.assignees.map((item) => item.id);
	},
	beforeDestroy() {
		this.reset();
	},
};
</script>

<style lang="scss">
.members {
	max-height: 200px;

	.custom-control {
		margin-bottom: 0.5rem;
	}
}
</style>
